(function () {
    'use strict';

    angular
        .module('loyalty')
        .controller('LoyaltyExpiringController', LoyaltyExpiringController);
        LoyaltyExpiringController.$inject = ['LoyaltyService', 'SellerService'];
    function LoyaltyExpiringController(LoyaltyService, SellerService) {
        var vm = this;
        vm.flag = false;
        vm.activate = activate;
        vm.getByFilter = getByFilter;
        vm.sellerSelected = -1;
        vm.getSellers = getSellers;
        vm.downloadCSV = downloadCSV;

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function getByFilter()
        {
            vm.flag = false;
            vm.query = {};
            vm.query['page'] = vm.page;
            if(vm.sellerSelected != -1) {
                vm.query['seller_id'] = vm.sellerSelected;
            }
            LoyaltyService.getExpiringPoints(vm.query).then(function(response) {
                vm.flag = true;
                vm.result = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            });
        }

        function getSellers() {
            vm.sellers = [];
            SellerService.getAll().then(function (response) {
                vm.sellers = response.data;
                vm.sellers.unshift({id : -1, name : '-- All -- '});
                // angular.forEach(response.data, function(value) {
                //     this.push({id : value.semester, name : value.semester });
                // }, vm.semesters);
            });
        }

        function downloadCSV() {
            vm.query = {};
            if(vm.sellerSelected != -1) {
                vm.query['seller_id'] = vm.sellerSelected;
            }

            LoyaltyService.getExpiringPointsCSV(vm.query).success(function(data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                anchor.download = 'report_fpp_points.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            }).error(function(data, status, headers, config) {
                // handle error
            });
        }

        function activate()
        {
            vm.getSellers();
            vm.getByFilter();
        }

        vm.activate();
    }
})();